export default __webpack_public_path__ + "static/media/linkedin.086baa50.svg";